import { Conexion } from "../../../Config/Coneccion";
class CotizacionConexion extends Conexion {
    clase = 'Cotizacion';
    persistencia = 1000;
}
var conCot: CotizacionConexion;
export default function conCotizacion() {
    if (conCot === undefined) conCot = new CotizacionConexion();
    return conCot;
}